export const track = (name, payload) => {
  if (typeof window !== 'undefined') {
    window.LIFE_CYCLE_EVENT_BUS.trigger(name, payload);
  }
};
